import { Component, OnInit } from '@angular/core';
// Forms
import { FormGroup, FormGroupDirective } from '@angular/forms';

export enum VehicleType {
  Unknown = 'Unknown',
  Multirotor = 'Multirotor',
  Helicopter = 'Helicopter',
  Fixedwind = 'Fixedwind',
  Hybrid = 'Hybrid'
}

export enum VehicleClass {
  C0 = 'C0',
  C1 = 'C1',
  C2 = 'C2',
  C3 = 'C3',
  C4 = 'C4',
  C5 = 'C5',
  C6 = 'C6'
}

@Component({
  selector: 'app-vehicle-details',
  templateUrl: './vehicle-details.component.html',
  styleUrls: ['./vehicle-details.component.scss'],
})

export class VehicleDetailsComponent  implements OnInit {

  /**
   * Variables
   */
  VehicleForm: FormGroup;

  /**
   * Enum variables
   */
  vehicleTypes = Object.values(VehicleType);
  vehicleClasses = Object.values(VehicleClass);

  constructor(private rootFormGroup: FormGroupDirective) { }

  // #region --> LifeCycle

  /**
   * Every time the component is rendered, we take from the parent the vehicle form.
   */
  ngOnInit() {
    this.VehicleForm = this.rootFormGroup.control;
  }

  // #endregion --> LifeCycle

}
